






















































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
import Loading from '@/app/components/Common/Loading.vue'
import FieldMap from '@/app/components/Field/FieldMap.vue'
import FieldList from '@/app/components/Field/FieldList.vue'
/* api */
import FieldListApi from '@/app/model/api/fieldListApi'
import FieldSortApi from '@/app/model/api/fieldSortApi'
import FieldDetailsApi from '@/app/model/api/fieldDetailsApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, fieldDetailsApiFlag, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    Loading,
    FieldMap,
    FieldList
  }
})
export default class FieldChoiceModal extends Vue {
  private isOpend: any = {}
  /* データ */
  private accordionData: Array<{[key:string]: string}> = []
  private accordionList: any = []
  private mapList: Array<{[key:string]: any}> = []
  private fieldList: Array<{[key:string]: any}> = []
  private target: string = '1'
  private defultFieldList: any = []
  private accordionLoading: any = {}
  /* 表示非表示 */
  private showListLoading: boolean = true
  private renderList: boolean = false
  private accordionChangeFlag: boolean = true
  private accordionFlag: boolean = true
  private showNotFound: boolean = false

  /* computed */
  private get fieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.modalId
  }

  @Watch('fieldChoiceState')
  onIdChange (id: string) {
    if (this.decisionPlanting(id)) {
      this.getFieldName(id)
    }
    if (id !== '' && id !== null) {
      let el: any = document.getElementById(id)

      if (el !== null && el !== undefined) {
        let acoordionId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
        let index = acoordionId.indexOf('/')
        let id = acoordionId.slice(index + 1)

        this.openSpecificAccordion(id)
        if (el && this.$store.state.fieldChoiceState.isScroll) {
          el.scrollIntoView({ behavior: 'instant' })
        } else {
          this.$store.commit('fieldChoiceState/setIsScroll', true)
        }
      } else {
        this.foundFieldAccordionId()
      }
    }
  }

  private foundFieldAccordionId () {
    let isDone = false
    for (let i in this.accordionList) {
      for (let j in this.accordionList[i]) {
        if (this.accordionList[i][j].field_id !== undefined &&
            this.accordionList[i][j].field_id === parseInt(this.$store.state.fieldChoiceState.modalId)) {
          this.isOpenedAccordion(this.accordionList[i].accordion_id)
          isDone = true
          break
        }
      }
      if (isDone) {
        break
      }
    }
  }

  created () {
    (async () => {
      const result = await FieldListApi.getFieldData(true, '0', {})

      if (result.isOk()) {
        this.showNotFound = false
        // グループ分けしていない圃場一覧を保持
        this.defultFieldList = result.getPayload().fields
        const fieldsGroub = this.groupBy(result.getPayload().fields, this.target)

        /* マップのデータを作成 */
        this.mapList = []
        if (result.getPayload().fields.length !== 0) {
          this.makeAccordionData(fieldsGroub)

          /* マップデータ作成 */
          for (var j in result.getPayload().fields) {
            this.createDataList(result.getPayload().fields[j], parseInt(j))

            /* エリアデータをlocalstorageに保存 */
            let accordionData = result.getPayload().fields[j]
            accordionData['timestamp'] = Date.now()
          }
          this.mapCreate()
        } else {
          this.showNotFound = true
        }
        this.showListLoading = false
        this.$store.commit('setFlagState/setFieldModalDetailsFlag', true)
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  private displayAccordionData: Array<{[key:string]: string|number}> = []

  private makeAccordionData (fieldsGroub: any) {
    // リセット
    this.displayAccordionData = []

    let accordionList: any = []
    // アコーディオン名とIDをセット
    for (var k in fieldsGroub) {
      if (this.target === '1') {
        fieldsGroub[k].accordion_id = fieldsGroub[k][0].district.district_id
        fieldsGroub[k].accordion_name = fieldsGroub[k][0].district.district_code + '\n' + fieldsGroub[k][0].district.district_name
        fieldsGroub[k].sort_number = fieldsGroub[k][0].district.sort_number
      } else if (this.target === '2') {
        // nullの場合は（作付けなし）と表示
        if (fieldsGroub[k][0].planting.variety === null) {
          fieldsGroub[k].accordion_id = 0
          fieldsGroub[k].accordion_name = '（作付けなし）'
        } else {
          fieldsGroub[k].accordion_id = fieldsGroub[k][0].planting.variety.variety_id
          fieldsGroub[k].accordion_name = fieldsGroub[k][0].planting.variety.variety_name
        }
        fieldsGroub[k].sort_number = null
      } else {
        // nullの場合は（作付けなし）と表示
        if (fieldsGroub[k][0].planting.user === null) {
          fieldsGroub[k].accordion_id = 0
          fieldsGroub[k].accordion_name = '（作付けなし）'
        } else {
          fieldsGroub[k].accordion_id = fieldsGroub[k][0].planting.user.user_id
          fieldsGroub[k].accordion_name = fieldsGroub[k][0].planting.user.user_name
        }
        fieldsGroub[k].sort_number = null
      }

      accordionList.push({
        accordion_id: fieldsGroub[k].accordion_id,
        accordion_name: fieldsGroub[k].accordion_name,
        sort_number: fieldsGroub[k].sort_number
      })
    }

    // アコーディオンを並び替え
    if (this.target === '1') {
      accordionList.sort(function (a: any, b: any) {
        // 並び順の昇順
        if (a.sort_number < b.sort_number) {
          return -1
        }
        if (a.sort_number > b.sort_number) {
          return 1
        }
        // 地区名の昇順
        if (a.accordion_name < b.accordion_name) {
          return -1
        }
        if (a.accordion_name > b.accordion_name) {
          return 1
        }
        return 0
      })
    } else if (this.target === '2') {
      accordionList.sort(function (a: any, b: any) {
        // 品種名の昇順
        if (a.accordion_name < b.accordion_name) {
          return -1
        }
        if (a.accordion_name > b.accordion_name) {
          return 1
        }
        return 0
      })
    } else {
      accordionList.sort(function (a: any, b: any) {
        // 生産者名の昇順
        if (a.accordion_name < b.accordion_name) {
          return -1
        }
        if (a.accordion_name > b.accordion_name) {
          return 1
        }
        // user_idの昇順
        if (a.accordion_id < b.accordion_id) {
          return -1
        }
        if (a.accordion_id > b.accordion_id) {
          return 1
        }
        return 0
      })
    }

    this.accordionList = fieldsGroub
    this.displayAccordionData = accordionList

    setTimeout(this.foundFieldAccordionId, 1000)
  }

  private groupBy (array: any, key: any) {
    if (key === '1') {
      // 地区
      return array.reduce(function (rv: any, x: any) {
        (rv[x.district.district_id] = rv[x.district.district_id] || []).push(x)
        return rv
      }, {})
    } else if (key === '2') {
      // 品種
      return array.reduce(function (rv: any, x: any) {
        if (x.planting.variety === null) {
          (rv[x.planting.variety] = rv[x.planting.variety] || []).push(x)
        } else {
          (rv[x.planting.variety.variety_id] = rv[x.planting.variety.variety_id] || []).push(x)
        }
        return rv
      }, {})
    } else {
      // 生産者
      return array.reduce(function (rv: any, x: any) {
        if (x.planting.user === null) {
          (rv[x.planting.user] = rv[x.planting.user] || []).push(x)
        } else {
          (rv[x.planting.user.user_id] = rv[x.planting.user.user_id] || []).push(x)
        }
        return rv
      }, {})
    }
  }

  /* ターゲットの変更 */
  private async changeTarget () {
    this.showListLoading = true
    this.$store.commit('setFlagState/setFieldModalDetailsFlag', true)

    /* アコーディオンを一度すべて閉じる */
    for (var i in this.accordionList) {
      let id = this.accordionList[i].accordion_id
      this.$set(this.isOpend, id, false)
    }
    this.displayAccordionData = []

    const fieldsGroub = this.groupBy(this.defultFieldList, this.target)
    this.makeAccordionData(fieldsGroub)

    this.showListLoading = false
  }

  private fieldDetailsData: any[] = []

  /* 詳細データ取得 */
  private getFieldDetailsData (id: number, idFlag: boolean) : any {
    (async () => {
      if (id !== 0 && id !== undefined) {
        // アコーディオンのローディングを表示
        this.$set(this.accordionLoading, id, true)
        let searchItem = {
          accordion: this.target,
          refile: 0,
          stage: '',
          variety: '',
          risk: 0,
          word: ''
        }

        const result = await FieldDetailsApi.getFieldDetailsData(String(id), idFlag, fieldDetailsApiFlag.FLAG_FIELD, searchItem, [])
        if (result.isOk()) {
          if (result.getPayload() === null) {
            return
          }

          for (let i in result.getPayload().field_details) {
            this.fieldDetailsData.push(result.getPayload().field_details[i])
          }
          result.getPayload().field_details.unshift({ timestamp: Date.now() })

          Session.setModalFieldDetailsData(JSON.stringify(result.getPayload().field_details), String(id))
          // 保存したグルーピングの情報を保持
          Session.setChoiceModalGrouping(this.target)

          /* データ取得フラグ */
          this.$store.commit('setFlagState/setFieldModalDetailsFlag', true)

          let fieldList: any = this.$refs.fieldList
          if (fieldList !== undefined) {
            for (var i in fieldList) {
              if (fieldList[i].id === id) {
                fieldList[i].showLoading = false
              }
            }
          }
          // 取得した圃場の一覧を表示する
          for (let q in this.displayAccordionData) {
            if (this.displayAccordionData[q].accordion_id === id) {
              this.displayAccordionData[q] = this.accordionList[id]
              break
            }
          }
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
        }
        this.$set(this.accordionLoading, id, false)
      }
    })()
  }

  /* 取得したデータからリストを作成 */
  private createDataList (result: any, key: number) {
    const mapData: any = {
      id: result.field_id,
      path: result.polygon.point,
      strokeColor: result.polygon.polygon_color,
      fillColor: result.polygon.polygon_color,
      fieldComSensor1: this.getSensorLatLng('fieldCom1', result.field_cam_sensor),
      fieldComSensor2: this.getSensorLatLng('fieldCom2', result.field_cam_sensor),
      fieldServerSensor: this.getSensorLatLng('fieldServer', result.field_server_sensor),
      paddyWatchSensor: this.getSensorLatLng('paddyWatch', result.paddy_watch_sensor)
    }

    const fieldData: any = {
      fieldName: result.field_name,
      fieldId: result.field_id,
      plantingId: result.planting.planting_id,
      accordionDistrictId: this.getAccordionId('district', result.district),
      accordionVarietyId: this.getAccordionId('variety', result.planting.variety),
      accordionUserId: this.getAccordionId('user', result.planting.user)
    }

    if (result.polygon.point === null) {
      mapData.fieldPosition = {
        lat: parseFloat(result.point.lat),
        lng: parseFloat(result.point.lng)
      }
    }

    this.mapList[key] = mapData
    this.fieldList[key] = fieldData
  }

  private getAccordionId (key: string, data: any) {
    if (data === null) {
      return 0
    }

    if (key === 'district') {
      return data.district_id
    } else if (key === 'variety') {
      return data.variety_id
    } else {
      return data.user_id
    }
  }

  private getSensorLatLng (sensorType: string, data: any) {
    if (sensorType === 'fieldServer' || sensorType === 'paddyWatch') {
      if (data !== null) {
        return data.point
      }
    } else {
      let displayNumber
      if (sensorType === 'fieldCom1') {
        displayNumber = 1
      } else {
        displayNumber = 2
      }
      for (let i in data) {
        if (data[i] !== undefined && data[i].display_number === displayNumber) {
          return data[i].point
        }
      }
    }
    return null
  }

  /* ポリゴン表示 */
  private mapCreate () {
    if (this.mapList.length !== 0) {
      /* リストの一番上のデータをマップの中心にする */
      if (Session.getChoiceFieldId()! === null) {
        if (this.mapList[0].path !== null) {
          if (this.$store.state.mapState.basicData.position.lng === this.mapList[0].path[0].lng) {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
          } else {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[0])
          }
        } else {
          let lat
          let lng
          if (this.mapList[0].fieldPosition.lat !== undefined) {
            lat = this.mapList[0].fieldPosition.lat
            lng = this.mapList[0].fieldPosition.lng
          } else {
            lat = this.mapList[0].field_lat
            lng = this.mapList[0].field_lng
          }

          this.$store.commit('mapState/setBaseData', {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          })
        }
      } else {
        if (this.mapList[0].path !== null) {
          this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
        } else {
          let lat
          let lng
          if (this.mapList[0].fieldPosition.lat !== undefined) {
            lat = this.mapList[0].fieldPosition.lat
            lng = this.mapList[0].fieldPosition.lng
          } else {
            lat = this.mapList[0].field_lat
            lng = this.mapList[0].field_lng
          }

          this.$store.commit('mapState/setBaseData', {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          })
        }
      }
    }
  }

  private decisionPlanting (id: string) {
    let plantingId = this.$store.state.fieldChoiceState.modalPlantingId

    for (var i in this.fieldList) {
      if (id === this.fieldList[i].fieldId) {
        if (plantingId === 0) {
          return false
        } else {
          return true
        }
      }
    }
  }

  /* 圃場選択 */
  private getFieldName (id: string) {
    for (var i in this.fieldList) {
      if (this.fieldList[i].fieldId === id) {
        this.$emit('get-field-name', this.fieldList[i].fieldName)
        this.$emit('get-field-id', this.fieldList[i].fieldId)
      }
    }
  }

  /* アコーディオン */
  private isOpenedAccordion (key: number) {
    let getAccordionData: any = []
    for (let i in this.displayAccordionData) {
      if (this.displayAccordionData[i].accordion_id === key) {
        getAccordionData = this.displayAccordionData[i]
      }
    }

    if (!this.accordionLoading[key]) {
      if (getAccordionData.length === undefined || getAccordionData.length === 0) {
        this.getFieldDetailsData(key, true)
      }
      this.accordionChangeFlag = !this.accordionChangeFlag
      this.$set(this.isOpend, key, !this.isOpend[key])
    }
  }

  private openSpecificAccordion (areaId: string) {
    let key = parseInt(areaId)
    if (!this.isOpend[key] && !this.accordionLoading[key]) {
      this.getFieldDetailsData(key, true)
      this.$set(this.isOpend, key, true)
    }
  }

  private afterTransition () {
    let id = this.$store.state.fieldChoiceState.modalId
    let el: any = document.getElementById(String(id))

    if (el) {
      el.scrollIntoView({ behavior: 'instant' })
    }
  }
}
